module.exports = __webpack_public_path__ + "img/0d0ac57.png";